import Vue from 'vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App.vue'
import Routes from './routes'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './styles/fonts.scss';
import './styles/bootstrap-theme.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
//import AxiosPlugin from 'vue-axios-cors';
import VueSessionStorage from "vue-sessionstorage";
Vue.use(VueSessionStorage);
import axios from 'axios'

Vue.prototype.$http = axios
//Vue.use(AxiosPlugin);
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const router = new VueRouter({
    routes: Routes,
    mode: 'history'
})

new Vue({
    render: h => h(App),
    router: router
}).$mount('#app')